import axios, { AxiosError } from "axios";
import { useParams } from "react-router-dom";
import AfficheProduit from "../../Views/Admin/HomeAdmin/AfficheProduit";
import { SetStateAction, useEffect, useState } from "react";
import AfficheProduitByIdCommercial from "../../Views/Commercial/Produit/AfficheProduitByIdCommercial";

export default function AfficheProduitByIdCommercialService() {
  const [Designation, setDesignation] = useState<string>("");
  const [IdArticle, setIdArticle] = useState<number>(0);
  const [PrixVenteArticleTTC, setPrixVenteArticleTTC] = useState<string>("");
  const [RefArticle, setRefArticle] = useState<string>("");
  const [image, setimage] = useState<any>("");
  const [Description, setDescription] = useState<string>("");
  const [stock, setstock] = useState<string>("");
  const [LibelleSubstitut, setLibelle] = useState<string>("")
  const [QantityMagasin, setQantityMagasin] = useState<string>("")
  const [prix_ht_1_magasin, setPrixHt1] = useState<string>("")
  const [prix_ht_2_magasin, setPrixHt2] = useState<string>("")
  const [prix_ht_3_magasin, setPrixHt3] = useState<string>("")
  const [prix_ttc, setPrixTtc] = useState<string>("")
  const [NomMagasin, setNomMagasin] = useState<string>("")
  const [NomMarque, setNomMarque] = useState<string>("")



    const { id: paramId, ref, NameMagasin } = useParams<{ id?: string; ref?: string; NameMagasin?: any }>(); 
    const id = paramId || localStorage.getItem('CommercialId');  
    const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchProduct();
  }, [id, NameMagasin, ref])

  const fetchProduct = async () => {
    try {
      setLoading(true);
      await axios.get(process.env.REACT_APP_PHP_APP_URL +`/commercials/${id}/${NameMagasin}/articles/${ref}`)
        .then(({ data }) => {
          console.log(data);
          setIdArticle(data.IdArticle);
          setDescription(data.Description);
          setDesignation(data.Designation);
          setPrixVenteArticleTTC(data.PrixNetHT);
          setLibelle(data.LibelleSubstitut);
          setRefArticle(data.RefArticle);
          // Backend cache normalizes Quantité → 'Qte'. Read all possible variants.
          const rawStock = data.Qte ?? data.Quantité ?? data.Quantite ?? data.quantite ?? data.quantity ?? data.stock ?? "";
          setstock(String(rawStock));
          setQantityMagasin(data.quantity_Zenpart);
          setNomMagasin(data.NomMagasin);
          setNomMarque(data.NomMarque);
          setimage(data.urlImage);
          setPrixHt1(data.prixht1_Zenpart);
          setPrixHt2(data.prixht2_Zenpart);
          setPrixHt3(data.prixht3_Zenpart);
          setPrixTtc(data.prixttc_Zenpart);
        })
    } catch (error: AxiosError | any) {
      if (error.response?.status === 442) {
        console.log("good data");
      } else {
        console.log("error");
      }
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#FAFAFA' }}>
        <div style={{ width: '40px', height: '40px', border: '4px solid #f3f3f3', borderTop: '4px solid #F5A623', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
        <span style={{ marginTop: '16px', color: '#64748B', fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>Chargement des informations...</span>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return <>
    <AfficheProduitByIdCommercial
      IdArticle={IdArticle}
      Designation={Designation}
      NomMagasin={NomMagasin}
      NomMarque={NomMarque}

      PrixVenteArticleTTC={PrixVenteArticleTTC}
      LibelleSubstitut={LibelleSubstitut}
      RefArticle={RefArticle}
      image={image}
      Description={Description}
      stock={stock}
      quantité={stock !== "" && !isNaN(Number(stock)) ? Number(stock) : undefined}
      QantityMagasin={QantityMagasin}
      prix_ht_1_magasin={prix_ht_1_magasin}
      prix_ht_2_magasin={prix_ht_2_magasin}
      prix_ht_3_magasin={prix_ht_3_magasin}
      prix_ttc={prix_ttc}
      Unite={""} setDesignation={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setPrixVenteArticleTTC={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setDescription={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setImage={function (value: SetStateAction<File | null>): void {
        throw new Error("Function not implemented.");
      }} setstock={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setRefARticle={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setUnite={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setprix_ht_2_magasin={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setprix_ht_3_magasin={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setprix_ht_1_magasin={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setquantité={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setNomClient={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setAdresse={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setTotalCommandeHT={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} setTotalRemise={function (value: SetStateAction<string>): void {
        throw new Error("Function not implemented.");
      }} />
  </>
}